import stateDialogPC from './state_dialog_PC.vue'
const state_dialog_PC = {
    install: function (Vue) {
        Vue.component('state_dialog_PC', stateDialogPC)
    }
};
// 导出组件
export default state_dialog_PC